export const isMac = () => /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent);
